// eslint-disable-next-line no-unused-vars
import AxiosHelper from "../helper/AxiosHelper";

class AuthAxios extends AxiosHelper {
    // eslint-disable-next-line getter-return
    static get axios() {
        // eslint-disable-next-line no-undef
        return AxiosHelper.getInstance()
    }
}

export default AuthAxios;